// extracted by mini-css-extract-plugin
module.exports = {"selfChartsWrapper":"SimulationResultsPresentation_selfChartsWrapper__18iFd","rowDisplay":"SimulationResultsPresentation_rowDisplay__3lMaN"};